<script setup lang="ts">
import type { Subscription } from '@entities/subscription'

import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

import { useSubscriptionOptions } from '../model/subscription-options'

defineOptions({
  name: 'SubscriptionProviderCell',
})

defineProps<{
  subscription: Subscription
}>()

const { getProviderLabel } = useSubscriptionOptions()
</script>

<template>
  <LinkTextPrimary
    v-if="subscription.provider_url"
    :href="subscription.provider_url"
    target="_blank"
  >
    {{ getProviderLabel(subscription.provider) }}
    <template #iconRight>
      <AppIcon
        :icon="faArrowUpRightFromSquare"
        size="small"
      />
    </template>
  </LinkTextPrimary>
  <AppText
    v-else
    name="body1"
    color="slate-900"
  >
    {{ getProviderLabel(subscription.provider) }}
  </AppText>
</template>
